import { useState } from "react";
import { Link } from "react-router-dom";
import { FileClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Panel, Initials } from "@/components/kit";
import { useStore } from "@/store/AppStore";
import { teamOf } from "@/lib/selectors";
import { monthLabel } from "@/pages/TimesheetPage";
import { TODAY } from "@/data/mock";

const lastMonths = () => {
  const [y, m] = TODAY.split("-").map(Number);
  return Array.from({ length: 6 }, (_, i) => {
    const d = new Date(y, m - 1 - i, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
};

export function TimesheetPicker({ companyId }) {
  const { state } = useStore();
  const months = lastMonths();
  const [month, setMonth] = useState(months[0]);
  return (
    <Panel title="Espelho de ponto" subtitle="Folha mensal de cada colaboradora para conferência, assinatura e arquivo" testId="timesheet-picker" action={
      <div className="w-44"><Select value={month} onValueChange={setMonth}><SelectTrigger data-testid="timesheet-month-select"><SelectValue /></SelectTrigger><SelectContent>{months.map((k) => <SelectItem key={k} value={k}>{monthLabel(k)}</SelectItem>)}</SelectContent></Select></div>
    }>
      {!teamOf(state, companyId).length && <p className="text-sm text-neutral-400">Nenhuma colaboradora cadastrada.</p>}
      <ul className="divide-y divide-neutral-100">
        {teamOf(state, companyId).map((c) => (
          <li key={c.id} className="flex items-center gap-3 py-3">
            <Initials name={c.name} />
            <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold">{c.name}</p><p className="text-xs text-neutral-500">{c.role}</p></div>
            <Button asChild size="sm" variant="outline" data-testid={`timesheet-open-${c.id}`}><Link to={`/espelho-ponto?colab=${c.id}&mes=${month}`}><FileClock className="mr-1 h-4 w-4 text-gold-dark" /> Abrir espelho</Link></Button>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
